import React, { useState, useEffect } from "react";
import apiClient from '../Utils/apiClient';
import {
  Line
} from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend
} from "chart.js";

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend
);

const LoginStatsDashboard = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    email: "",
    company_ids: [14, 39],
    date_from: "2026-03-01",
    date_to: "2026-03-30",
    interval: "day"
  });

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await apiClient.post("analytics/login-success-stats", filters);
      setData(res.data.data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const chartData = {
    labels: data.map(d => new Date(d.period).toLocaleDateString()),
    datasets: [
      {
        label: "Unique Logins",
        data: data.map(d => d.unique_logins),
        borderColor: "#3b82f6",
        backgroundColor: "#93c5fd",
        tension: 0.3
      }
    ]
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: true
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "company_ids") {
      setFilters({
        ...filters,
        company_ids: value.split(",").map(Number)
      });
    } else {
      setFilters({
        ...filters,
        [name]: value
      });
    }
  };

  return (
    <div className="main-panel">
      <div className="content-wrapper">
          <div className="card registration_form" >
              <div className="modal-header">
                  <h3 className='card-heading'>Verification Logs</h3>
              </div>
                <div className="card">
                  <div className="card-body">
                    <div style={{ padding: "20px" }}>
                      <h2>📈 Login Success Dashboard</h2>

                      <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
                          <div className="form-group">
                            <input
                              type="text"
                              name="email"
                              className="form-control"
                              placeholder="Email (optional)"
                              value={filters.email}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="form-group">
                              <input
                                type="text"
                                name="company_ids"
                                className="form-control"
                                placeholder="Company IDs (e.g. 14,39)"
                                onChange={handleChange}
                              />
                           </div>
                           <div className="form-group">
                              <input
                                type="date"
                                name="date_from"
                                className="form-control"
                                value={filters.date_from}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="form-group">
                              <input
                                type="date"
                                name="date_to"
                                className="form-control"
                                value={filters.date_to}
                                onChange={handleChange}
                              />
                            </div>
                             <div className="form-group">
                                <select
                                  name="interval"
                                  className="form-control"
                                  value={filters.interval}
                                  onChange={handleChange}
                                >
                                <option value="day">Daily</option>
                                <option value="week">Weekly</option>
                                <option value="month">Monthly</option>
                              </select>
                            </div>
                            <div className="form-group">
                            <button  className="btn btn-warning float-start" onClick={fetchData}>Apply</button>
                            </div>
                      </div>

                      <div style={{ marginBottom: "40px" }}>
                        {loading ? (
                          <p>Loading...</p>
                        ) : (
                          <Line data={chartData} options={chartOptions} />
                        )}
                      </div>

                      <table border="1" cellPadding="10">
                        <thead>
                          <tr>
                            <th>Period</th>
                            <th>Unique Logins</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.map((row, idx) => (
                            <tr key={idx}>
                              <td>{new Date(row.period).toLocaleDateString()}</td>
                              <td>{row.unique_logins}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
    </div>
    </div>
    </div>
  );
};

export default LoginStatsDashboard;